<template>
  <div class="upload-detail">
    <div class="info-item title">Upload Sales Receipt</div>
    <div class="info-item">Submission Time：{{ infoObj.localCreateTime }}</div>
    <div class="info-item img-content">
      <div>Image：</div>
      <div class="img-info item-img">
        <img v-for="(imgItem, imgIndex) in infoObj.imgUrl" :key="imgIndex" class="img-icon" :src="imgItem" alt="" @click="imgPreview(imgIndex)">
      </div>
    </div>
    <div class="info-item">Audit Result：<span :style="`color: ${infoObj.statusColor}`">{{ infoObj.statusText }}</span></div>
    <div class="info-item" v-if="infoObj.status === -1">Reason：{{ infoObj.failRemark }}</div>
    <div class="info-item" v-if="infoObj.orderType === 2">Sell-out Product {{ infoObj.totalQuantity }} PCS，earned {{ infoObj.totalIntegral }} points。</div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    infoObj: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    imgPreview (index) {
      ImagePreview({
        images: this.infoObj.imgUrl,
        startPosition: index
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upload-detail {
  padding: 28px 23px;
  font-size: 13px;
  .info-item {
    padding: 6px 0;
  }
  .title {
    font-weight: bold;
  }
  .img-content {
    display: flex;
    .item-img {
      flex: 1;
    }
  }
  .img-icon {
    width: 48px;
    height: 48px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
